import { DevicesAppNirvanaDataProvider } from '../dataProvider/DevicesAppNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ, API_TYPE_NIRVANA } from '../../../webcomponents.constants';

export class DevicesAppDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, DevicesAppNirvanaDataProvider);
  }
}
